export default __webpack_public_path__ + "static/media/reports-flour-active.13f0a57c.svg";